<template>
    <div class="commercial-policy-amount">
        <v-row class="px-0" v-for="(item, idx) in policies" :key="idx">
            <v-col cols="12" class="col-sm-6 col-md-3">
                <v-text-field v-model="policies[idx].minSum" label="Сумма от" color="teal" @change="changePolicy"/>
            </v-col>
            <v-col cols="12" class="col-sm-6 col-md-3">
                <v-text-field v-model="policies[idx].maxSum" label="Сумма до" color="teal" @change="changePolicy"/>
            </v-col>
            <v-col cols="12" class="col-sm-6 col-md-3">
                <v-select
                        v-model="policies[idx].currency"
                        label="Валюта" color="teal"
                        @change="changePolicy"
                        :items="currencies"
                        item-value="id"
                        item-text="name"
                />
            </v-col>
            <v-col cols="12" class="col-sm-6 col-md-3">
                <v-text-field v-model="policies[idx].discount" label="Размер скидки" color="teal" @change="changePolicy"/>
            </v-col>
            <v-col cols="12" class="mt-0">
                <v-btn text color="grey" @click="deletePolicy(item.id)">Удалить политику</v-btn>
            </v-col>
            <v-col cols="12" class="pa-0">
                <v-divider></v-divider>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import CommercialPolicyMixin from "./CommercialPolicyMixin"

    export default {
        name: "CommercialPolicyAmount",
        props:['currencies'],
        mixins: [CommercialPolicyMixin],
    }
</script>

<style scoped>

</style>